export const CLEAR_FLASH_MESSAGE = "CLEAR_FLASH_MESSAGE";
export const CLEAR_PROMISE = "CLEAR_PROMISE";
export const CLEAR_TEMP_NUM_RESULTS = "CLEAR_TEMP_NUM_RESULTS";
export const PUSH_FLASH_MESSAGE = "PUSH_FLASH_MESSAGE";
export const SET_COUNTRY_CODE = "SET_COUNTRY_CODE";
export const SET_DNS_ENVIRONMENT = "SET_DNS_ENVIRONMENT";
export const SET_LANGUAGE_CODE = "SET_LANGUAGE_CODE";
export const SET_MODULES_ENVIRONMENT = "SET_MODULES_ENVIRONMENT";
export const SET_PROMISE = "SET_PROMISE";
export const SET_TOP_LEVEL_ZONE = "SET_TOP_LEVEL_ZONE";
export const TOGGLE_FAVOURITE = "TOGGLE_FAVOURITE";
export const UPDATE_FAVOURITE = "UPDATE_FAVOURITE";
export const UPDATE_NUM_RESULT = "UPDATE_NUM_RESULT";
